import { css } from "styled-components";

const ptSerif_caption_base = css`
  font-family: var(--font-pt-serif);
  font-style: normal;
  letter-spacing: 0;
  line-height: 1.43rem;
`;
export const ptSerif_caption_lg_bold = css`
  ${ptSerif_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-bold);
`;

export const ptSerif_caption_lg_regular = css`
  ${ptSerif_caption_base};
  font-size: var(--text-caption-size-lg);
  font-weight: var(--text-weight-regular);
`;
export const ptSerif_caption_md_bold = css`
  ${ptSerif_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-bold);
  line-height: 1.3rem;
`;
export const ptSerif_caption_md_regular = css`
  ${ptSerif_caption_base};
  font-size: var(--text-caption-size-md);
  font-weight: var(--text-weight-regular);
`;
